<template>
  <div class="d-flex" :key="key">
    <Header class="side-nav-header"></Header>
    <div class="main-container-div">
      <div class="content-wrapper">
        <section class="content-lines-wrapper">
          <div class="content-lines-inner">
            <div class="content-lines"></div>
          </div>
        </section>
        <section
          class="banner-header banner-img valign bg-img bg-fixed"
          data-overlay-darkgray="5"
          style="background-image: url(img/banner.jpg)"
        ></section>

        <section class="section-padding2">
          <div class="container">
            <div class="row">
              <div class="col-md-12" >
                <h2 class="section-description" id="title">Drain Board</h2>
              </div>
            </div>
            <div class="row descriptionAppend" >
              <!-- <div class="items"></div> -->
              <!-- {{description}} -->
              <div class="col-md-12" id="description">
                <!-- description start -->
                <p>The styled to your quality taste</p>
                <table class="table text-center">
                  <tr class="active">
                    <th>Overall Size</th>
                    <th>Bowl Size</th>
                    <th>Finish</th>
                    <th>Pcs Per Box</th>
                  </tr>
                  <tr>
                    <td>37"x18"x9"</td>
                    <td>17"x16"</td>
                    <td>Matt</td>
                    <td>1 Pcs</td>
                  </tr>
                </table>
                <!-- description end -->
              </div>
            </div>
            <div class="row mt-30">
              <div v-for="(images,i) in image" :key="i" class="col-sm-6" >
                <div class="col-md-6 gallery-item ">
                <a class="img-zoom">
                  <div class="gallery-box">
                    <div class="gallery-img">
                      <img
                       :src=images
                        class="img-fluid mx-auto d-block"
                        alt="product-img"
                      />
                    </div>
                  </div>
                </a>
              </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Prev-Next Projects -->
        <section class="projects-prev-next">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div
                  class="d-sm-flex align-items-center justify-content-between"
                >
                  <div class="projects-prev-next-left"></div>
                  <router-link to="/product">
                    <a 
                      ><i class="ti-arrow-left mr-10"></i> Back to Products</a
                    ></router-link
                  >
                  <div class="projects-prev-next-right"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import $ from "jquery";

export default {
  name: "OurProductDetails",

  components: {
    Header,
    Footer,
  },
  data() {
    return {
      hire: null,
      url_data: null,
      description:null,
      image:[],
      key:1
    };
  },

  mounted() {
    // console.log("this.$route.params",this.$route.params.name)

    this.fillupdata();
    window.scrollTo(0, 0);
  },
  watch: {
    "$route.params": {
      handler: async function () {
        await this.fillupdata();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    fillupdata() {
      this.url_data = this.$route.query.name;
      console.log("item... this.url_data", this.url_data);

      var service = {
        single_bowl_1: {
          title: "Single Bowl",
          description: `<p>The styled to your quality taste</p>
                  <table class="table text-center">
                      <tr class="active">
                          <th>Overall Size</th>
                          <th>Bowl Size</th>
                          <th>Finish</th>
                          <th>Pcs Per Box</th>
                      </tr>
                      <tr>
                          <td>18"x16"x9"</td>
                          <td>16"x14"</td>
                          <td>Matt</td>
                          <td>1 Pcs</td>
                      </tr>
                      <tr>
                          <td>21"x18"x9"</td>
                          <td>19"x16"</td>
                          <td>Matt</td>
                          <td>1 Pcs</td>
                      </tr>
                      <tr>
                          <td>24"x18"x10"</td>
                          <td>22"x16"</td>
                          <td>Matt</td>
                          <td>1 Pcs</td>
                      </tr>
                  </table>`,
          images: [
            "img/product/single-bowl-1.jpg",
            "img/product/single-bowl-1-2.jpg",
            "img/product/single-bowl-1-1.jpg",
          ],
        },
        double_bowl_1: {
          title: "Double Bowl",
          description: `<p>The styled to your quality taste</p>
        <table class="table text-center">
            <tr class="active">
                <th>Overall Size</th>
                <th>Bowl Size</th>
                <th>Finish</th>
                <th>Pcs Per Box</th>
            </tr>
            <tr>
                <td>32"x18"x9"</td>
                <td>14.5"x14"</td>
                <td>Matt</td>
                <td>1 Pcs</td>
            </tr>
            <tr>
                <td>32"x18"x9"</td>
                <td>14.5"x16"</td>
                <td>Matt</td>
                <td>1 Pcs</td>
            </tr>
        </table>`,
          images: ["img/product/double-bowl-1.jpg", "img/product/double-bowl-1-1.jpg"],
        },
        double_bowl_2: {
          title: "Double Bowl",
          description: `<p>The styled to your quality taste</p>
    <table class="table text-center">
        <tr class="active">
            <th>Overall Size</th>
            <th>Bowl Size</th>
            <th>Finish</th>
            <th>Pcs Per Box</th>
        </tr>
        <tr>
            <td>37"x18"x9"</td>
            <td>17"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
        <tr>
            <td>37"x18"x9"</td>
            <td>17"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
    </table>`,
          images: ["img/product/double-bowl-2.jpg", "img/product/double-bowl-2-1.jpg"],
        },
        drain_board_1: {
          title: "Drain Board",
          description: `<p>The styled to your quality taste</p>
    <table class="table text-center">
        <tr class="active">
            <th>Overall Size</th>
            <th>Bowl Size</th>
            <th>Finish</th>
            <th>Pcs Per Box</th>
        </tr>
        <tr>
            <td>37"x18"x9"</td>
            <td>17"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
    </table>`,
          images: [
            "img/product/drain-board-1.jpg",
            "img/product/drain-board-1-1.jpg",
            "img/product/drain-board-1-2.jpg",
          ],
        },
        single_bowl_2: {
          title: "Single Bowl",
          description: `<p>The styled to your quality taste</p>
    <table class="table text-center">
        <tr class="active">
            <th>Overall Size</th>
            <th>Bowl Size</th>
            <th>Finish</th>
            <th>Pcs Per Box</th>
        </tr>
        <tr>
            <td>24"x18"x10"</td>
            <td>22"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
    </table>`,
          images: ["img/product/single-bowl-2.jpg", "img/product/single-bowl-2-1.jpg"],
        },
        single_bowl_3: {
          title: "Single Bowl",
          description: `<p>The styled to your quality taste</p>
    <table class="table text-center">
        <tr class="active">
            <th>Overall Size</th>
            <th>Bowl Size</th>
            <th>Finish</th>
            <th>Pcs Per Box</th>
        </tr>
        <tr>
            <td>18"x16"x9"</td>
            <td>16"x14"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
        <tr>
            <td>20"x17"x9"</td>
            <td>18"x15"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
        <tr>
            <td>21"x18"x9"</td>
            <td>19"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
        <tr>
            <td>22"x18"x9"</td>
            <td>20"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
    </table>`,
          images: ["img/product/single-bowl-3.jpg", "img/product/single-bowl-3-1.jpg"],
        },
        single_bowl_4: {
          title: "Single Bowl",
          description: `<p>The styled to your quality taste</p>
    <table class="table text-center">
        <tr class="active">
            <th>Overall Size</th>
            <th>Bowl Size</th>
            <th>Finish</th>
            <th>Pcs Per Box</th>
        </tr>
        <tr>
            <td>24"x18"x9"</td>
            <td>22"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
        <tr>
            <td>24"x18"x10"</td>
            <td>22"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
        <tr>
            <td>32"x18"x9"</td>
            <td>30"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
    </table>`,
          images: [
            "img/product/single-bowl-4.jpg",
            "img/product/single-bowl-4-1.jpg",
            "img/product/single-bowl-4-2.jpg",
          ],
        },
        double_bowl_3: {
          title: "Double Bowl",
          description: `<p>The styled to your quality taste</p>
    <table class="table text-center">
        <tr class="active">
            <th>Overall Size</th>
            <th>Bowl Size</th>
            <th>Finish</th>
            <th>Pcs Per Box</th>
        </tr>
        <tr>
            <td>32"x18"x9"</td>
            <td>14.5"x14"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
        <tr>
            <td>37"x18"x9"</td>
            <td>14.5"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
    </table>`,
          images: ["img/product/double-bowl-3.jpg", "img/product/double-bowl-3-1.jpg"],
        },
        double_bowl_4: {
          title: "Double Bowl",
          description: `<p>The styled to your quality taste</p>
    <table class="table text-center">
        <tr class="active">
            <th>Overall Size</th>
            <th>Bowl Size</th>
            <th>Finish</th>
            <th>Pcs Per Box</th>
        </tr>
        <tr>
            <td>37"x18"x9"</td>
            <td>17"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
        <tr>
            <td>37"x18"x9"</td>
            <td>17"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
    </table>`,
          images: ["img/product/double-bowl-4.jpg", "img/product/double-bowl-4-1.jpg"],
        },
        drain_bowl_2: {
          title: "Drain Board",
          description: `<p>The styled to your quality taste</p>
    <table class="table text-center">
        <tr class="active">
            <th>Overall Size</th>
            <th>Bowl Size</th>
            <th>Finish</th>
            <th>Pcs Per Box</th>
        </tr>
        <tr>
            <td>37"x18"x9"</td>
            <td>17"x16"</td>
            <td>Matt</td>
            <td>1 Pcs</td>
        </tr>
    </table>`,
          images: [
            "img/product/drain-board-2.jpg  ",
            "/img/product/double-bowl-4-1.jpg",
            "img/product/drain-board-1-2.jpg",
          ],
        },
      };
      // console.log("service", service);
      var item = service[this.url_data];
      console.log("item...", item);
      console.log("item...title", item.title);
      $(document).ready(function () {
        $("#title").text(item.title);
        $(".descriptionAppend").empty().append(item.description);
      });
      this.image= item.images;
      this.key++
    },
  },
};
</script>

<style>
/* .owl-carousel .bg-img{
    background-repeat: no-repeat;
    background-size: cover;
} */
@media screen and (max-width: 768px) {
  /* .owl-carousel .bg-img{
        background-repeat: no-repeat;
        background-size: auto 100vh;
    }
    .owl-item{
        width: 100vw !important;
    } */
  .main-container-div {
    width: 100%;
  }
}
@media screen and (min-width: 768px) {
  .side-nav-header {
    width: 21%;
  }
  .main-container-div {
    width: 79%;
  }
}
</style>
